import { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { db } from "../firebase";
import { capitalizeFirstLetter } from "./services";
import { current } from "@reduxjs/toolkit";

const Button = ({ children }) => {
  return (
    <button className="w-max max-w-full hover:bg-darkblue  bg-blue text-white p-2 text-sm">
      {children}
    </button>
  );
};
const Badge = ({ children, className }) => {
  return (
    <span
      className={`${
        className ? className : ""
      } w-max max-w-full  text-white px-2 py-1 text-sm`}
    >
      {children}
    </span>
  );
};

const SearchBar = ({ setResult,clear }) => {
  const searchText = useRef();
  const [query, setQuery] = useState("");
  const [result, loading] = useCollectionData(query);
  const [finalResult, setfinalResult] = useState(null);
  useEffect(() => {
    setfinalResult(result);
    setResult(result);
    clear()
  }, [result]);

  const handleSearch = (e) => {
    e.preventDefault();
    const nquery = db
      .collection("websites")
      .where("title", "==", searchText.current.value.toLowerCase());
    setQuery(nquery);
  };
  return (
    <form onSubmit={handleSearch} className="w-max max-w-full flex flex-col">
      <div className="flex items-center">
        <input
          type="search "
          name=""
          ref={searchText}
          onChange={() => {
            setfinalResult(null);
            setResult([]);
          }}
          placeholder="Search websites"
          className="px-4 py-2 w-full max-w-xs border border-black border-opacity-20"
        />
        <button className="w-max max-w-full bg-blue px-4 py-2 text-white ml-2">
          Search
        </button>
      </div>
      {loading && <p className="text-base  italic mt-4">Searching...</p>}
      {!loading && result && finalResult && (
        <p className="text-base  italic mt-4">
          {result.length === 1
            ? `1 result found for '${searchText.current.value}'`
            : result.length === 0
            ? `No result found for '${searchText.current.value}'`
            : `${result.length} results found for '${searchText.current.value}'`}
        </p>
      )}
    </form>
  );
};
const SelectCatogary = ({ setFilter ,clear}) => {
  const pagesRef = useRef();
  const typeRef = useRef();
  const [query, setQuery] = useState("");
  const [result, loading] = useCollectionData(query);
  const [fresult, setFResult] = useState(null);
  const handleFilter = (e) => {
    e.preventDefault();
    if (typeRef.current.value || pagesRef.current.value) {
      let nq = db
        .collection("websites")
        .where("filter", "array-contains-any", [
          typeRef.current.value,
          pagesRef.current.value,
        ]);
      setQuery(nq);
    }
  };
  useEffect(() => {
    setFilter(result);
    setFResult(result);
    clear()
  }, [result]);
  return (
    <form
      onSubmit={handleFilter}
      className="w-max max-w-full h-max flex-wrap gap-2 flex flex-col items-start"
    >
      <div className="flex gap-2 flex-wrap">
        <select
          name=""
          ref={pagesRef}
          onChange={() => {
            setFilter([]);
            setFResult(null);
          }}
          className="px-4 py-2  max-w-xs border border-black border-opacity-20"
        >
          <option value="" defaultValue>
            Pages
          </option>
          <option value="1">1 Page</option>
          <option value="2">2 Pages</option>
          <option value="3">3 Pages</option>
          <option value="4">4 Pages</option>
          <option value="5">5 Pages</option>
        </select>
        <select
          name=""
          onChange={() => {
            setFilter([]);
            setFResult(null);
          }}
          ref={typeRef}
          className="px-4 py-2  max-w-xs border border-black border-opacity-20"
        >
          <option value="" defaultValue>
            Catagory
          </option>
          <option value="portfolio">Portfolio</option>
          <option value="blog">Blog</option>
          <option value="landing">Landing</option>
          <option value="home">Home Page</option>
        </select>
        <button className="w-max max-w-full bg-blue px-4 py-2 text-white ml-2">
          Filter
        </button>
      </div>
      {loading && <p className="text-base  italic mt-4">Searching...</p>}
      {!loading && result && fresult && (
        <p className="text-base  italic mt-4">
          {result.length === 1
            ? `1 result found for 'pages : ${pagesRef.current.value}' 'catogary:${typeRef.current.value}'`
            : result.length === 0
            ? `No results found for 'pages : ${pagesRef.current.value}' 'catogary:${typeRef.current.value}'`
            : `${result.length} results found for 'pages : ${pagesRef.current.value}'  'catogary:${typeRef.current.value}'`}
        </p>
      )}
    </form>
  );
};

const Item = ({
  title,
  type,
  pages,
  link,
  cover,
  price,
  sold,
  id,
  payment_pending,
}) => {
  const cardStyle = {
    backgroundImage: `url(${cover})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
  return (
    <div className="flex flex-col w-72 max-w-full">
      <Link to={`/web/${id}`}>
        <div
          className="h-64 w-72 max-w-full bg-black relative"
          style={cardStyle}
        >
          {!sold && !payment_pending && (
            <Badge className="bg-green font-bold hover absolute bottom-2 right-2">
              New
            </Badge>
          )}
          {sold && !payment_pending && (
            <Badge className="bg-red font-bold hover absolute bottom-2 right-2">
              Sold Out
            </Badge>
          )}
          {payment_pending && (
            <Badge className="bg-gray font-bold hover absolute bottom-2 right-2">
              Order Pending
            </Badge>
          )}
        </div>
      </Link>
      <div className="mt-2 flex items-center justify-between w-full">
        <div className="textl-lg  font-medium w-full truncate">
          {capitalizeFirstLetter(title)}
        </div>
        <div className="text-2xl font-bold flex-shrink-0 ml-2">{price}$</div>
      </div>
      <div className="mt-2 flex items-center justify-between w-full">
        <div className="text-sm">{pages} Pages</div>
        <div className="text-sm">{capitalizeFirstLetter(type)}</div>
      </div>
      {!sold && (
        <div className="flex w-full mt-4 flex-wrap gap-x-4 gap-y-4">
          {!payment_pending && (
            <Link to={`/order/${id}`}>
              <Button>Order</Button>
            </Link>
          )}
          <a target="_blank" rel="noreferrer" href={link}>
            <Button>Preview</Button>
          </a>
        </div>
      )}
    </div>
  );
};

const STORE = () => {
  const wrapper = useRef();
  const [showTop, setShowTop] = useState(false);
  const query = db.collection("websites").orderBy("uploaded");
  const [websites, loading, error] = useCollectionData(query);
  const history = useHistory();
  const [searchResult, setSearchResult] = useState([]);
  const [filterResult, setFilterResult] = useState(false);
  const makeShow = () => {
    if (wrapper.current) {
      if (wrapper.current.scrollTop > wrapper.current.scrollHeight / 4) {
        setShowTop(true);
      } else {
        setShowTop(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", makeShow);
    return () => window.removeEventListener("scroll", makeShow);
  }, []);
  useEffect(() => {
    if (error) {
      alert(
        "Something happened while fetching data. If this happens continuesly please contact us. Redirecting..."
      );
      history.push("/sign-in");
    }
  }, [error]);
  return (
    <div
      ref={wrapper}
      className="w-full flex flex-col h-full py-12 items-center overflow-y-auto"
    >
      <div className="w-full sm:px-4 flex flex-wrap gap-6  justify-between ">
        <SearchBar
          setResult={(items) => setSearchResult(items)}
          clear={() => setFilterResult([])}
        />
        <SelectCatogary
          setFilter={(items) => {
            setFilterResult(items);
          }}
          clear={() => setSearchResult([])}
        />
      </div>
      {filterResult && filterResult.length !== 0 && (
        <div className="w-full gap-12 mb-24 flex flex-wrap pt-12 justify-center">
          {filterResult.map(
            ({
              id,
              title,
              type,
              pages,
              cover,
              link,
              price,
              sold,
              payment_pending,
            }) => (
              <Item
                key={id}
                title={title}
                id={id}
                price={price}
                type={type}
                sold={sold}
                cover={cover}
                pages={pages}
                link={link}
                payment_pending={payment_pending}
              />
            )
          )}
        </div>
      )}
      {searchResult && searchResult.length !== 0 && (
        <div className="w-full gap-12 mb-24 flex flex-wrap pt-12 justify-center">
          {searchResult.map(
            ({
              id,
              title,
              type,
              pages,
              cover,
              link,
              price,
              sold,
              payment_pending,
            }) => (
              <Item
                key={id}
                title={title}
                id={id}
                price={price}
                type={type}
                sold={sold}
                cover={cover}
                pages={pages}
                link={link}
                payment_pending={payment_pending}
              />
            )
          )}
        </div>
      )}
      <div className="w-full gap-12 flex flex-wrap pt-12 justify-center">
        {websites &&
          websites.map(
            ({
              id,
              title,
              type,
              pages,
              cover,
              link,
              price,
              sold,
              payment_pending,
            }) => (
              <Item
                key={id}
                title={title}
                id={id}
                price={price}
                type={type}
                sold={sold}
                cover={cover}
                pages={pages}
                link={link}
                payment_pending={payment_pending}
              />
            )
          )}
      </div>
      {loading && <p className="text-base w-full italic mt-4">Loading...</p>}

      {showTop && (
        <button
          onClick={() => {
            if (wrapper.current) {
              wrapper.current.scrollTop = 0;
            }
          }}
          style={{ left: "50%", transform: "translateX(-50%)" }}
          className="fixed bottom-0 w-max text-white right-0 px-4 py-2 bg-black"
        >
          Go to top
        </button>
      )}
    </div>
  );
};

export default STORE;
